import dayjs from 'dayjs';
import { Badge } from '@mantine/core';

export function DueDateBadge({ dueDate, isPending }: { dueDate: Date; isPending: boolean }) {
  const date = dayjs(dueDate);
  const referenceDate = date.hour() === 0 ? dayjs().endOf('day') : dayjs();
  const hoursOverdue = date.diff(referenceDate, 'hour');
  const tomorrowEndOfDay = dayjs().endOf('day').add(1, 'day');

  let color = 'blue';
  if (!isPending) {
    color = 'green';
  } else if (hoursOverdue < 0) {
    color = 'red';
  } else if (hoursOverdue < tomorrowEndOfDay.diff(date, 'hour')) {
    color = 'orange';
  }

  return (
    <Badge variant="outline" color={color} style={{ cursor: 'pointer', flexShrink: 0 }}>
      {dayjs(dueDate).format('L')}
    </Badge>
  );
}
